import { render, staticRenderFns } from "./EventOrganizerEditDialog.vue?vue&type=template&id=1df2574c"
import script from "./EventOrganizerEditDialog.js?vue&type=script&lang=js&external"
export * from "./EventOrganizerEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports